import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-admin-layout',
  templateUrl: './admin-layout.component.html',
  styleUrl: './admin-layout.component.scss',
  standalone: false,
})
export class AdminLayoutComponent implements OnInit {
  constructor() {}

  ngOnInit() {}
}
